import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Avion = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.2 63.02">
  <G fill={color}>
    <Path d="M5.46,38c.13.68.68,2.34,2.97,3.03,2.56.77,6.52,1.23,10.25,1.23,3.03,0,5.9-.3,7.76-.99,3.4-1.25,46.53-21.57,51.87-24.61,3.65-2.08,3.98-4.7,3.86-6.08-.31-3.35-3.68-5.7-5.87-6.46-2.75-.95-8.57-1.06-10.97.14-.2.1-1.03.48-2.36,1.09-2.54,1.16-7.1,3.26-12.56,5.82L29.44.31c-.4-.2-.84-.31-1.28-.31h-9.99c-1.13,0-2.15.68-2.58,1.73-.43,1.05-.19,2.25.61,3.05l15.35,15.28c-4.82,2.28-9.05,4.32-10.98,5.26l-11.1-4.44c-.74-.3-1.57-.26-2.29.09l-5.63,2.81c-.77.38-1.31,1.1-1.49,1.93-.17.84.05,1.71.6,2.37l5.59,6.65c-.6.92-1.02,2.05-.79,3.27Z"/>
    <Path d="M78.67,57.43H3.98c-1.54,0-2.8,1.25-2.8,2.8s1.25,2.8,2.8,2.8h74.69c1.54,0,2.8-1.25,2.8-2.8s-1.25-2.8-2.8-2.8Z"/>
  </G>
</Svg>
);
};

export default Avion;
